import { useEffect, useRef, useState } from "react";

const values = [
  {
    icon: "ri-user-heart-line",
    title: "Authenticity",
    desc: "Real connections start when you show up as you are. No filters, no performance.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Safety",
    desc: "Structured events and a reputation system create a safer space for everyone.",
  },
  {
    icon: "ri-community-line",
    title: "Community",
    desc: "Find your people through shared interests before romance ever enters the picture.",
  },
  {
    icon: "ri-heart-2-line",
    title: "Respect",
    desc: "We build a space where everyone feels safe, seen, and respected to be themselves.",
  },
];

export default function ValuesSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className={`text-center mb-14 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="text-xs font-semibold text-[#7C55CC] uppercase tracking-widest mb-3">Our Values</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Built on values that matter
          </h2>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 transition-all duration-700 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {values.map((v, i) => (
            <div
              key={i}
              className="bg-[#F5F5F5] rounded-3xl p-8 flex flex-col gap-4 hover:-translate-y-1 hover:shadow-lg hover:shadow-[#C8B6FF]/20 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-[#E6D9FF]">
                <i className={`${v.icon} text-xl text-[#7C55CC]`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">{v.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
